// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"826f1c73","239":"d83436f3","732":"5d9c5e9f"}[chunkId] + ".chunk.js";
};